'use strict';

var axios = require('axios');
var getHost = require('./getHost-bdfdb786.js');
var md5 = require('md5');
var http = require('./http-bb56b50d.js');
function _interopDefaultLegacy(e) {
  return e && typeof e === 'object' && 'default' in e ? e : {
    'default': e
  };
}
var axios__default = /*#__PURE__*/_interopDefaultLegacy(axios);
var md5__default = /*#__PURE__*/_interopDefaultLegacy(md5);

/*! *****************************************************************************
Copyright (c) Microsoft Corporation.

Permission to use, copy, modify, and/or distribute this software for any
purpose with or without fee is hereby granted.

THE SOFTWARE IS PROVIDED "AS IS" AND THE AUTHOR DISCLAIMS ALL WARRANTIES WITH
REGARD TO THIS SOFTWARE INCLUDING ALL IMPLIED WARRANTIES OF MERCHANTABILITY
AND FITNESS. IN NO EVENT SHALL THE AUTHOR BE LIABLE FOR ANY SPECIAL, DIRECT,
INDIRECT, OR CONSEQUENTIAL DAMAGES OR ANY DAMAGES WHATSOEVER RESULTING FROM
LOSS OF USE, DATA OR PROFITS, WHETHER IN AN ACTION OF CONTRACT, NEGLIGENCE OR
OTHER TORTIOUS ACTION, ARISING OUT OF OR IN CONNECTION WITH THE USE OR
PERFORMANCE OF THIS SOFTWARE.
***************************************************************************** */
/* global Reflect, Promise */

var _extendStatics = function extendStatics(d, b) {
  _extendStatics = Object.setPrototypeOf || {
    __proto__: []
  } instanceof Array && function (d, b) {
    d.__proto__ = b;
  } || function (d, b) {
    for (var p in b) {
      if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p];
    }
  };
  return _extendStatics(d, b);
};
function __extends(d, b) {
  if (typeof b !== "function" && b !== null) throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
  _extendStatics(d, b);
  function __() {
    this.constructor = d;
  }
  d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
}
exports.__assign = function () {
  exports.__assign = Object.assign || function __assign(t) {
    for (var s, i = 1, n = arguments.length; i < n; i++) {
      s = arguments[i];
      for (var p in s) {
        if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p];
      }
    }
    return t;
  };
  return exports.__assign.apply(this, arguments);
};
function __rest(s, e) {
  var t = {};
  for (var p in s) {
    if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0) t[p] = s[p];
  }
  if (s != null && typeof Object.getOwnPropertySymbols === "function") for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
    if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i])) t[p[i]] = s[p[i]];
  }
  return t;
}
function __awaiter(thisArg, _arguments, P, generator) {
  function adopt(value) {
    return value instanceof P ? value : new P(function (resolve) {
      resolve(value);
    });
  }
  return new (P || (P = Promise))(function (resolve, reject) {
    function fulfilled(value) {
      try {
        step(generator.next(value));
      } catch (e) {
        reject(e);
      }
    }
    function rejected(value) {
      try {
        step(generator["throw"](value));
      } catch (e) {
        reject(e);
      }
    }
    function step(result) {
      result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected);
    }
    step((generator = generator.apply(thisArg, _arguments || [])).next());
  });
}
function __generator(thisArg, body) {
  var _ = {
      label: 0,
      sent: function sent() {
        if (t[0] & 1) throw t[1];
        return t[1];
      },
      trys: [],
      ops: []
    },
    f,
    y,
    t,
    g;
  return g = {
    next: verb(0),
    "throw": verb(1),
    "return": verb(2)
  }, typeof Symbol === "function" && (g[Symbol.iterator] = function () {
    return this;
  }), g;
  function verb(n) {
    return function (v) {
      return step([n, v]);
    };
  }
  function step(op) {
    if (f) throw new TypeError("Generator is already executing.");
    while (_) {
      try {
        if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
        if (y = 0, t) op = [op[0] & 2, t.value];
        switch (op[0]) {
          case 0:
          case 1:
            t = op;
            break;
          case 4:
            _.label++;
            return {
              value: op[1],
              done: false
            };
          case 5:
            _.label++;
            y = op[1];
            op = [0];
            continue;
          case 7:
            op = _.ops.pop();
            _.trys.pop();
            continue;
          default:
            if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) {
              _ = 0;
              continue;
            }
            if (op[0] === 3 && (!t || op[1] > t[0] && op[1] < t[3])) {
              _.label = op[1];
              break;
            }
            if (op[0] === 6 && _.label < t[1]) {
              _.label = t[1];
              t = op;
              break;
            }
            if (t && _.label < t[2]) {
              _.label = t[2];
              _.ops.push(op);
              break;
            }
            if (t[2]) _.ops.pop();
            _.trys.pop();
            continue;
        }
        op = body.call(thisArg, _);
      } catch (e) {
        op = [6, e];
        y = 0;
      } finally {
        f = t = 0;
      }
    }
    if (op[0] & 5) throw op[1];
    return {
      value: op[0] ? op[1] : void 0,
      done: true
    };
  }
}
function __spreadArray(to, from) {
  for (var i = 0, il = from.length, j = to.length; i < il; i++, j++) {
    to[j] = from[i];
  }
  return to;
}
function createRequest(config) {
  config.report;
  var axiosConfig = __rest(config, ["report"]);
  var instance = axios__default['default'].create(exports.__assign({
    withCredentials: true,
    timeout: 60000
  }, axiosConfig));
  return instance;
}
var passGateway = '';
var passWSGateway = '';
var passBFFGateway = '';
function configPassGateWay(gateway) {
  if (typeof gateway === 'string') {
    passGateway = gateway;
  }
  /**
   * seller 网关针对 ws 有独立的 path, 没法用一个统一的 passGateway
   */
  if (typeof gateway === 'object') {
    var _a = gateway.http,
      http = _a === void 0 ? '' : _a,
      _b = gateway.websocket,
      websocket = _b === void 0 ? '' : _b,
      _c = gateway.bff,
      bff = _c === void 0 ? '' : _c;
    if (!http || !websocket) {
      console.warn('Invalid gateway value', gateway);
    }
    passGateway = http;
    passWSGateway = websocket;
    passBFFGateway = bff;
  }
}
function getPassGateWay(baseURL) {
  return (baseURL === null || baseURL === void 0 ? void 0 : baseURL.includes('/bff/')) ? getPassBFFGateWay() : passGateway;
}
function getPassBFFGateWay() {
  return passBFFGateway;
}
function getPassWSGateWay() {
  return passWSGateway;
}

/*  Function to test if an object is a plain object, i.e. is constructed
**  by the built-in Object constructor and inherits directly from Object.prototype
**  or null. Some built-in objects pass the test, e.g. Math which is a plain object
**  and some host or exotic objects may pass also.
**
**  @param {} obj - value to test
**  @returns {Boolean} true if passes tests, false otherwise
*/
function isPlainObject(obj) {
  // Basic check for Type object that's not null
  if (typeof obj === 'object' && obj !== null) {
    // If Object.getPrototypeOf supported, use it
    if (typeof Object.getPrototypeOf === 'function') {
      var proto = Object.getPrototypeOf(obj);
      return proto === Object.prototype || proto === null;
    }
    // Otherwise, use internal class
    // This should be reliable as if getPrototypeOf not supported, is pre-ES5
    return Object.prototype.toString.call(obj) === '[object Object]';
  }
  // Not an object
  return false;
}
function filteredNullFromResponse(data) {
  if (data === null) {
    return undefined;
  }
  if (isPlainObject(data)) {
    return Object.entries(data).reduce(function (acc, _a) {
      var key = _a[0],
        value = _a[1];
      acc[key] = filteredNullFromResponse(value);
      return acc;
    }, {});
  }
  return data;
}
var metricsTypeMap = {
  count: 'count',
  time: 'time_costs',
  hyper: 'hyper',
  gauge: 'gauge',
  histogram: 'histogram',
  summary: 'summary'
};
function reportDebugLog(message, data) {
  var _a, _b;
  if (data === void 0) {
    data = {};
  }
  var logFunction = (_a = window.CSChannelChat) === null || _a === void 0 ? void 0 : _a.logReport;
  // @ts-ignore
  (_b = logFunction === null || logFunction === void 0 ? void 0 : logFunction.info) === null || _b === void 0 ? void 0 : _b.call(logFunction, {
    message: message + " " + JSON.stringify(data)
  });
}
function reportErrorLog(message, data) {
  var _a, _b;
  if (data === void 0) {
    data = {};
  }
  var logFunction = (_a = window.CSChannelChat) === null || _a === void 0 ? void 0 : _a.logReport;
  // @ts-ignore
  (_b = logFunction === null || logFunction === void 0 ? void 0 : logFunction.error) === null || _b === void 0 ? void 0 : _b.call(logFunction, {
    message: message + " " + JSON.stringify(data)
  });
}
var TraceLogger = /** @class */function () {
  function TraceLogger(props) {
    var _a = props !== null && props !== void 0 ? props : {},
      id = _a.id,
      _b = _a.sessionId,
      sessionId = _b === void 0 ? '' : _b,
      accountId = _a.accountId,
      accountName = _a.accountName,
      platform = _a.platform;
    this.traceId = id;
    this.commonParams = {
      session_id: sessionId,
      accountId: accountId,
      accountName: accountName,
      platform: platform
    };
  }
  TraceLogger.prototype.debug = function (message, data) {
    if (data === void 0) {
      data = {};
    }
    reportDebugLog(message, exports.__assign(exports.__assign(exports.__assign({}, this.commonParams), data), {
      traceId: this.traceId,
      wsReqId: this.wsReqId
    }));
  };
  TraceLogger.prototype.error = function (message, data) {
    if (data === void 0) {
      data = {};
    }
    reportErrorLog(message, exports.__assign(exports.__assign(exports.__assign({}, this.commonParams), data), {
      traceId: this.traceId,
      wsReqId: this.wsReqId
    }));
  };
  TraceLogger.prototype.setWsReqId = function (wsReqId) {
    this.wsReqId = wsReqId;
  };
  TraceLogger.prototype.updateSessionId = function (sessionId) {
    if (!sessionId) {
      return;
    }
    this.commonParams.session_id = sessionId;
  };
  return TraceLogger;
}();
function batchReportGrafana(data) {
  var _a, _b;
  var type = data.type,
    value = data.value;
  var _c = value || {},
    label = _c.label,
    cost = _c.cost,
    count = _c.count,
    extend_1 = _c.extend_1,
    extend_2 = _c.extend_2;
  var group = [extend_1, extend_2].filter(function (item) {
    return item !== undefined;
  });
  var reportQueueFunction = (_a = window.CSChannelChat) === null || _a === void 0 ? void 0 : _a.metricsReport;
  var formatType = metricsTypeMap[type];
  var valueParam = cost === undefined && count === undefined ? {} : {
    value: cost || count || 0
  };
  // @ts-ignore
  (_b = reportQueueFunction === null || reportQueueFunction === void 0 ? void 0 : reportQueueFunction.send) === null || _b === void 0 ? void 0 : _b.call(reportQueueFunction, exports.__assign(exports.__assign({}, valueParam), {
    type: formatType,
    label: label,
    group: group
  }));
}
function batchReportGrafanaTime(label) {
  var time = Date.now();
  return function () {
    return batchReportGrafana({
      type: 'time',
      value: {
        label: label,
        cost: Date.now() - time
      }
    });
  };
}
var NEED_FILTER_PATHS = ['/report/v1/report_log', '/heartbeat' // chat检测冲突心跳接口
];

var generateReportUrl = function generateReportUrl(baseURL, url) {
  var _a;
  if (baseURL === void 0) {
    baseURL = '';
  }
  if (url === void 0) {
    url = '';
  }
  var httpReg = /^http(s)?:\/\//;
  if (httpReg.test(url)) {
    return url;
  } else {
    var formatBaseURL = baseURL.endsWith('/') ? baseURL : baseURL + "/";
    var formatURL = url.startsWith('/') ? url.slice(1) : url;
    return "" + (httpReg.test(baseURL) ? '' : (_a = window === null || window === void 0 ? void 0 : window.location) === null || _a === void 0 ? void 0 : _a.origin) + formatBaseURL + formatURL;
  }
};
function apiMonitorInterceptors(res) {
  var _a, _b, _c, _d;
  try {
    var status_1 = (res || {}).status;
    var _e = res || {},
      code = _e.code,
      config = _e.config,
      errResponse = _e.response,
      _f = _e.isAxiosError,
      isAxiosError = _f === void 0 ? false : _f;
    var response = isAxiosError ? errResponse : res;
    var _g = config.baseURL,
      baseURL = _g === void 0 ? '' : _g,
      _h = config.url,
      url = _h === void 0 ? '' : _h;
    var reportURL_1 = generateReportUrl(baseURL, url);
    var reportCode = typeof status_1 !== 'undefined' ? String(status_1) : typeof (errResponse === null || errResponse === void 0 ? void 0 : errResponse.status) !== 'undefined' ? String(errResponse === null || errResponse === void 0 ? void 0 : errResponse.status) : String(code || 'unknown');
    var isFilterAPI = NEED_FILTER_PATHS.some(function (filterPath) {
      return reportURL_1.indexOf(filterPath) !== -1;
    });
    if (isFilterAPI) {
      return;
    }
    if (isAxiosError) {
      reportErrorLog('network error', response || ((_b = (_a = res) === null || _a === void 0 ? void 0 : _a.toJSON) === null || _b === void 0 ? void 0 : _b.call(_a)));
    }
    var requestPerformance = (((_c = performance === null || performance === void 0 ? void 0 : performance.getEntriesByName) === null || _c === void 0 ? void 0 : _c.call(performance, (_d = response === null || response === void 0 ? void 0 : response.request) === null || _d === void 0 ? void 0 : _d.responseURL)) || [])[0];
    var cost = void 0;
    if (requestPerformance === null || requestPerformance === void 0 ? void 0 : requestPerformance.duration) {
      cost = Math.round(requestPerformance === null || requestPerformance === void 0 ? void 0 : requestPerformance.duration);
    } else {
      // @ts-ignore
      var start = config === null || config === void 0 ? void 0 : config.requestStartTime;
      var end = Date.now();
      cost = Math.round(end - start);
    }
    batchReportGrafana({
      type: 'time',
      value: {
        label: 'channel_chat_api_time_consuming',
        cost: cost,
        extend_1: reportURL_1,
        extend_2: reportCode // http response code
      }
    });
  } catch (error) {
    console.error(error);
  }
}
var handleSuccess = function handleSuccess(response) {
  var status = response.status,
    res = response.data;
  apiMonitorInterceptors(response);
  if (status >= 400) {
    var error = new Error("Request failed with status code " + (status || 'UNKNOWN'));
    error.response = response;
    return Promise.resolve(error);
  }
  if (res.code !== 0) {
    var error = new Error(res.msg || "Request failed with data code " + (res.code || 'UNKNOWN'));
    // @ts-ignore
    error.response = response;
    return Promise.resolve(error);
  }
  return Promise.resolve(exports.__assign(exports.__assign({}, filteredNullFromResponse(res)), {
    response: response
  }));
};
var handleError = function handleError(err) {
  apiMonitorInterceptors(err);
  return Promise.resolve(err);
};
function getRandomNumbers() {
  var _a, _b;
  if (window.crypto) {
    var array = new Uint8Array(16);
    (_b = (_a = window.crypto).getRandomValues) === null || _b === void 0 ? void 0 : _b.call(_a, array);
    return md5__default['default'](array);
  }
  return md5__default['default'](Date.now().toString());
}
function getRandomNumberWithTimeStamp() {
  var timestamp = Date.now();
  return getRandomNumbers() + "_" + timestamp;
}
var currentIdKey = "CURRENT_ID";
var masterIdKey = "MASTER_ID";
var masterHeartbeatKey = "MASTER_HEARTBEAT";
var chatBeforeInitMessageKey = "CHAT_BEFORE_INIT_MESSAGE";
var chatInitMessageKey = "CHAT_INIT_MESSAGE";
var chatSendMessageKey = "CHAT_SEND_MESSAGE";
var chatSendMessageCompleteKey = "CHAT_SEND_MESSAGE_COMPLETE";
var chatReceiveMessageKey = "CHAT_RECEIVE_MESSAGE";
var chatRestoreKey = "CHAT_RESTORE";
var chatCloseKey = "CHAT_CLOSE";
var chatStopKey = "CHAT_STOP";
var chatErrorKey = "CHAT_ERROR";
var chatUnSendMessageKey = "CHAT_UN_SEND_MESSAGE";
var chatConfigChangeKey = "CHAT_CONFIG_CHANGE";
var readedMessageCountKey = "READED_MESSAGE_COUNT";
var ratingChatKey = "RATING_CHAT";
var connectionInfoKey = "CONNECTION_INFO";
var initConnectionInfoKey = "INIT_CONNECTION_INFO";
var events = {};
var noNeedFilterKeys = [currentIdKey, masterIdKey, masterHeartbeatKey];
// This plug-in may run in non-DOM environments (e.g. React Native).
if (window && typeof window.addEventListener === "function") {
  window.addEventListener("storage", function (event) {
    var _a;
    if (event.key == null) {
      return;
    }
    var key = extractKey(event.key);
    if (events[key]) {
      var currentId_1 = getSessionStorage(currentIdKey);
      (_a = events[key]) === null || _a === void 0 ? void 0 : _a.forEach(function (listener) {
        var value;
        try {
          value = JSON.parse(event.newValue);
        } finally {
          if (noNeedFilterKeys.includes(key) || (value === null || value === void 0 ? void 0 : value.currentId) !== currentId_1) {
            listener === null || listener === void 0 ? void 0 : listener(value);
          }
        }
      });
    }
  });
}
function addMessageListener(key, listener) {
  if (events[key] == null) {
    events[key] = [];
  }
  events[key].push(listener);
}
function removeMessageListener(key, listener) {
  if (events[key] == null || events[key].length === 0) {
    return;
  }
  if (listener == null) {
    events[key] = [];
  } else {
    events[key] = events[key].filter(function (v) {
      return v !== listener;
    });
  }
}
function removeAllChatStorage() {
  [masterIdKey, masterHeartbeatKey, chatBeforeInitMessageKey, chatInitMessageKey, chatUnSendMessageKey, chatSendMessageKey, chatSendMessageCompleteKey, chatReceiveMessageKey, chatRestoreKey, chatCloseKey, chatErrorKey, chatConfigChangeKey].forEach(function (v) {
    return removeStorage(generateKey(v));
  });
}
var heartbeatInterval = 2 * 1000;
var masterTimerKey = 'MASTER_TIMER';
var MasterAgent = /** @class */function () {
  function MasterAgent(id) {
    var _this = this;
    this.quit = function () {
      if (getStorage(masterIdKey) !== _this.id) {
        return;
      }
      reportDebugLog('master normal left by user');
      setStorage(masterIdKey, null);
      setStorage(masterHeartbeatKey, null);
    };
    this.handlerForcedQuit = function () {
      var _a;
      var masterId = getStorage(masterIdKey);
      if (_this.id !== masterId && masterId) {
        devLog('master be forced change to worker');
        reportDebugLog('master be forced change to worker');
        _this.clear();
        (_a = _this.changeRole) === null || _a === void 0 ? void 0 : _a.call(_this);
        return true;
      }
      return false;
    };
    this.id = id;
    this.startHeartbeat();
    window.addEventListener("beforeunload", this.quit);
    addMessageListener(masterIdKey, this.handlerForcedQuit);
  }
  MasterAgent.prototype.addChangeRoleListener = function (callback) {
    this.changeRole = callback;
  };
  MasterAgent.prototype.startHeartbeat = function () {
    var _this = this;
    setStorage(masterHeartbeatKey, Date.now());
    this.timer = setInterval(function () {
      if (_this.handlerForcedQuit()) {
        return;
      }
      devLog("...heartbeat...");
      setStorage(masterHeartbeatKey, Date.now());
    }, heartbeatInterval);
    setStorage(masterTimerKey, this.timer);
  };
  MasterAgent.prototype.clear = function () {
    clearInterval(this.timer);
    removeMessageListener(masterIdKey);
    window.removeEventListener("beforeunload", this.quit);
  };
  return MasterAgent;
}();
var timeout = 4 * 1000;
var WorkerAgent = /** @class */function () {
  function WorkerAgent() {
    var _this = this;
    this.handlerMasterQuit = function (value) {
      var _a;
      if (value == null) {
        (_a = _this.changeRole) === null || _a === void 0 ? void 0 : _a.call(_this);
      }
    };
    this.handlerMasterCrush = function () {
      clearTimeout(_this.timer);
      _this.timer = setTimeout(function () {
        var _a;
        (_a = _this.changeRole) === null || _a === void 0 ? void 0 : _a.call(_this);
      }, timeout);
    };
    this.init();
  }
  WorkerAgent.prototype.init = function () {
    addMessageListener(masterIdKey, this.handlerMasterQuit);
    addMessageListener(masterHeartbeatKey, this.handlerMasterCrush);
  };
  WorkerAgent.prototype.reInit = function () {
    this.init();
  };
  WorkerAgent.prototype.addChangeRoleListener = function (callback) {
    this.changeRole = callback;
  };
  WorkerAgent.prototype.clear = function () {
    clearTimeout(this.timer);
    removeMessageListener(masterIdKey, this.handlerMasterQuit);
    removeMessageListener(masterHeartbeatKey, this.handlerMasterCrush);
  };
  return WorkerAgent;
}();
var getUserSession = function getUserSession(params, headers) {
  if (headers === void 0) {
    headers = {};
  }
  return __awaiter(void 0, void 0, void 0, function () {
    return __generator(this, function (_a) {
      switch (_a.label) {
        case 0:
          return [4 /*yield*/, fetch.get("/user_session", {
            params: params,
            baseURL: "/chat/v1",
            headers: headers
          })];
        case 1:
          return [2 /*return*/, _a.sent()];
      }
    });
  });
};
var getSessionInfo = function getSessionInfo(_a, headers) {
  var _b = _a.from,
    from = _b === void 0 ? "h5" : _b,
    channel = _a.channel;
  if (headers === void 0) {
    headers = {};
  }
  return __awaiter(void 0, void 0, void 0, function () {
    var res, _c, is_exist, session_key, status, live_agent_type, _d, common_ext_info, _e, sf_ext_info;
    return __generator(this, function (_f) {
      switch (_f.label) {
        case 0:
          if (!channel) {
            return [2 /*return*/, null];
          }
          return [4 /*yield*/, getUserSession({
            from: from,
            channel: channel
          }, headers)];
        case 1:
          res = _f.sent();
          if (res instanceof Error) {
            return [2 /*return*/, res];
          }
          _c = (res === null || res === void 0 ? void 0 : res.data) || {}, is_exist = _c.is_exist, session_key = _c.session_key, status = _c.status, live_agent_type = _c.live_agent_type, _d = _c.common_ext_info, common_ext_info = _d === void 0 ? {} : _d, _e = _c.sf_ext_info, sf_ext_info = _e === void 0 ? {} : _e;
          return [2 /*return*/, {
            status: status,
            isExist: is_exist === 1,
            sessionKey: session_key,
            channelType: live_agent_type,
            userSessionExtensionInfo: exports.__assign(exports.__assign({}, common_ext_info), sf_ext_info)
          }];
      }
    });
  });
};
var AgentChatScheduler = /** @class */function () {
  function AgentChatScheduler() {
    this.inited = false;
    this.chatting = false;
    this.chattingStatus = 'queue';
  }
  Object.defineProperty(AgentChatScheduler.prototype, "isMaster", {
    get: function get() {
      return getStorage(masterIdKey) === getSessionStorage(currentIdKey);
    },
    enumerable: false,
    configurable: true
  });
  AgentChatScheduler.prototype.init = function (config) {
    this.id = getRandomNumbers();
    devLog('init shared agent id = ', this.id);
    this.inited = true;
    this.config = config;
    this.workerAgent = new WorkerAgent();
    this.workerAgent.addChangeRoleListener(this.changeRoleToMaster.bind(this));
    setSessionStorage(currentIdKey, this.id);
  };
  AgentChatScheduler.prototype.becomeMasterSuccess = function () {
    return __awaiter(this, void 0, void 0, function () {
      var _this = this;
      return __generator(this, function (_a) {
        if (!this.inited) {
          return [2 /*return*/, true];
        }
        if (checkMasterIsExist()) {
          return [2 /*return*/, false];
        }
        setStorage(masterIdKey, this.id);
        // 处理多个tab同时刷新restore的情况
        return [2 /*return*/, new Promise(function (resolve) {
          setTimeout(function () {
            var masterId = getStorage(masterIdKey);
            devLog("become master", masterId);
            reportDebugLog('become master success');
            if (masterId != _this.id) {
              resolve(false);
            }
            resolve(true);
          }, 1000);
        })];
      });
    });
  };
  AgentChatScheduler.prototype.initMasterAgent = function (connection, restore, fromWorker) {
    var _a, _b, _c;
    if (restore === void 0) {
      restore = false;
    }
    if (!this.inited) {
      return;
    }
    if (this.isMaster && fromWorker) {
      return;
    }
    if (!restore) {
      [readedMessageCountKey, connectionInfoKey, initConnectionInfoKey].forEach(function (v) {
        return removeStorage(generateKey(v));
      });
      // 清空未读消息
      (_b = (_a = this.config.connectionHandlers).updateReadedMessage) === null || _b === void 0 ? void 0 : _b.call(_a, {
        readAll: true
      });
    }
    setStorage(masterIdKey, this.id);
    this.masterAgent = new MasterAgent(this.id);
    this.masterAgent.addChangeRoleListener(this.changeRoleToWorker.bind(this));
    this.addMasterListener(connection);
    (_c = this.workerAgent) === null || _c === void 0 ? void 0 : _c.clear();
    // 保存上一次的连接实例，在SharedAgentChat中reset方法调用
    window.__chatbotAgent = {};
    window.__chatbotAgent.connection = connection;
  };
  AgentChatScheduler.prototype.addMasterListener = function (connection) {
    var _this = this;
    var handleSendMessage = function handleSendMessage(data) {
      return __awaiter(_this, void 0, void 0, function () {
        var masterId, onlyForMaster, extraInfo, bizContent, result;
        return __generator(this, function (_a) {
          switch (_a.label) {
            case 0:
              masterId = getStorage(masterIdKey);
              if (this.id !== masterId) {
                return [2 /*return*/];
              }

              if (data == null) {
                return [2 /*return*/];
              }

              onlyForMaster = data.onlyForMaster, extraInfo = data.extraInfo, bizContent = __rest(data, ["onlyForMaster", "extraInfo"]);
              if (!onlyForMaster) {
                return [2 /*return*/];
              }

              reportDebugLog("master proxy send message", {
                content: bizContent.content
              });
              return [4 /*yield*/, connection.sendMessage(bizContent)];
            case 1:
              result = _a.sent();
              if (result instanceof Error) {
                this.config.connectionHandlers.sendMessageComplete({
                  error: result,
                  result: exports.__assign(exports.__assign({}, data), {
                    extraInfo: extraInfo
                  })
                });
              } else {
                this.config.connectionHandlers.sendMessageComplete({
                  result: exports.__assign(exports.__assign({
                    extraInfo: extraInfo
                  }, result), data)
                });
              }
              return [2 /*return*/];
          }
        });
      });
    };

    var handleClose = function handleClose(data) {
      if (!(data === null || data === void 0 ? void 0 : data.onlyForMaster)) {
        return;
      }
      delete data.onlyForMaster;
      connection.close(data);
    };
    addMessageListener(chatSendMessageKey, handleSendMessage);
    addMessageListener(chatCloseKey, handleClose);
    this.removeMasterListener = function () {
      // 停止agent与服务器的连接
      connection.stop();
      removeMessageListener(chatSendMessageKey, handleSendMessage);
      removeMessageListener(chatCloseKey, handleClose);
    };
  };
  AgentChatScheduler.prototype.changeRoleToWorker = function () {
    var _a, _b, _c;
    (_a = this.masterAgent) === null || _a === void 0 ? void 0 : _a.clear();
    this.masterAgent = undefined;
    (_b = this.removeMasterListener) === null || _b === void 0 ? void 0 : _b.call(this);
    (_c = this.workerAgent) === null || _c === void 0 ? void 0 : _c.reInit();
    this.config.fallbackToWorker();
  };
  AgentChatScheduler.prototype.changeRoleToMaster = function () {
    var _this = this;
    devLog("start change worker, chatting = " + this.chatting + ", master = " + this.isMaster);
    reportDebugLog('log', "start change worker, chatting = " + this.chatting + ", master = " + this.isMaster);
    if (!this.chatting || this.isMaster) {
      return;
    }
    setStorage(masterIdKey, this.id);
    this.delayExec(function () {
      return __awaiter(_this, void 0, void 0, function () {
        var status, connectionInfo, messageData, connection, initConnectionInfo, result, isExist, status_1, configInfo, messages;
        var _a, _b, _c, _d;
        return __generator(this, function (_e) {
          switch (_e.label) {
            case 0:
              devLog('new master arrive', this.id);
              reportDebugLog('new master arrive');
              this.masterAgent = new MasterAgent(this.id);
              this.masterAgent.addChangeRoleListener(this.changeRoleToWorker.bind(this));
              status = this.chattingStatus;
              connectionInfo = (_a = getStorage(connectionInfoKey)) !== null && _a !== void 0 ? _a : {};
              messageData = getStorage(chatReceiveMessageKey);
              if (status === 'queue') {
                connectionInfo = exports.__assign({
                  queue_position: (_b = messageData === null || messageData === void 0 ? void 0 : messageData.content) === null || _b === void 0 ? void 0 : _b.number
                }, connectionInfo);
              }
              return [4 /*yield*/, this.config.upgradeToMaster(status, exports.__assign(exports.__assign({}, (_c = connectionInfo) !== null && _c !== void 0 ? _c : {}), {
                fromWorker: true
              }))];
            case 1:
              connection = _e.sent();
              if (!(status === 'queue')) return [3 /*break*/, 3];
              reportDebugLog('new master need check current status');
              initConnectionInfo = getStorage(initConnectionInfoKey);
              return [4 /*yield*/, getSessionInfo({
                from: 'pc',
                channel: initConnectionInfo.channel
              })];
            case 2:
              result = _e.sent();
              if (result && !(result instanceof Error)) {
                isExist = result.isExist, status_1 = result.status;
                if (isExist && status_1 === http.UserSessionStatus.chatting) this.config.connectionHandlers.message({
                  msg_type: "CS_JOINED",
                  first: true
                });
                if (isExist && status_1 === http.UserSessionStatus.queuing) {
                  configInfo = getStorage(chatConfigChangeKey);
                  this.config.connectionHandlers.config(configInfo);
                }
              }
              _e.label = 3;
            case 3:
              this.addMasterListener(connection);
              messages = (_d = getStorage(chatUnSendMessageKey)) !== null && _d !== void 0 ? _d : [];
              messages.forEach(function (v) {
                return connection.sendMessage(v);
              });
              setStorage(chatUnSendMessageKey, []);
              return [2 /*return*/];
          }
        });
      });
    });
  };

  AgentChatScheduler.prototype.delayExec = function (fn) {
    var _this = this;
    // 延时执行restore操作，保证master不被覆盖
    setTimeout(function () {
      return __awaiter(_this, void 0, void 0, function () {
        var masterId;
        return __generator(this, function (_a) {
          masterId = getStorage(masterIdKey);
          if (masterId != this.id) {
            return [2 /*return*/];
          }

          fn();
          return [2 /*return*/];
        });
      });
    }, 1000);
  };
  AgentChatScheduler.prototype.close = function () {
    var _a, _b;
    this.chatting = false;
    removeAllChatStorage();
    (_a = this.masterAgent) === null || _a === void 0 ? void 0 : _a.clear();
    (_b = this.removeMasterListener) === null || _b === void 0 ? void 0 : _b.call(this);
  };
  return AgentChatScheduler;
}();
var agentChatScheduler = new AgentChatScheduler();
function checkMasterIsExist() {
  var _a;
  var now = Date.now();
  var masterId = getStorage(masterIdKey);
  var lastHeartbeat = (_a = getStorage(masterHeartbeatKey)) !== null && _a !== void 0 ? _a : 0;
  var isExist = masterId != null && now - lastHeartbeat <= heartbeatInterval * 2;
  // https://jira.shopee.io/browse/SPCB-13062
  // 去掉 chatInitMessageKey 标记判断，只要connect即判定为存在会话
  var isStorageValid = canEmit(chatBeforeInitMessageKey).can || canEmit(chatRestoreKey).can;
  return isExist && isStorageValid;
}
function canEmit(key) {
  var masterId = getStorage(masterIdKey);
  var data = getStorage(key);
  var can = (data === null || data === void 0 ? void 0 : data.masterId) === masterId;
  return {
    can: can,
    data: data
  };
}
function getSharedKey() {
  var _a, _b, _c;
  return (_c = (_b = (_a = agentChatScheduler.config) === null || _a === void 0 ? void 0 : _a.key) === null || _b === void 0 ? void 0 : _b.toLocaleUpperCase()) !== null && _c !== void 0 ? _c : '';
}
var prefix = "__CHATBOT_AGENT";
var generateKey = function generateKey(key) {
  return prefix + "_" + getSharedKey() + "_" + key;
};
var extractKey = function extractKey(key) {
  var _a;
  if (key === void 0) {
    key = '';
  }
  return (_a = key.split(prefix + "_" + getSharedKey() + "_")) === null || _a === void 0 ? void 0 : _a[1];
};
function setStorage(key, value) {
  localStorage.setItem(generateKey(key), JSON.stringify(value));
}
function getStorage(key) {
  var value = localStorage.getItem(generateKey(key));
  try {
    return JSON.parse(value);
  } catch (_a) {
    return undefined;
  }
}
function removeStorage(key) {
  localStorage.removeItem(key);
}
function setSessionStorage(key, value) {
  sessionStorage.setItem(generateKey(key), JSON.stringify(value));
}
function getSessionStorage(key) {
  var value = sessionStorage.getItem(generateKey(key));
  try {
    return JSON.parse(value);
  } catch (_a) {
    return undefined;
  }
}
function getCSChatUUID() {
  var _a;
  try {
    var storage = JSON.parse(localStorage.getItem("__csChat"));
    return (_a = storage === null || storage === void 0 ? void 0 : storage["uuid"]) !== null && _a !== void 0 ? _a : "";
  } catch (_b) {
    return "";
  }
}
function getCSChatRegion() {
  var _a;
  try {
    var storage = JSON.parse(localStorage.getItem("__csChat"));
    return (_a = storage === null || storage === void 0 ? void 0 : storage["chat_region"]) !== null && _a !== void 0 ? _a : "";
  } catch (_b) {
    return "";
  }
}
function devLog(message) {
  var optionalParams = [];
  for (var _i = 1; _i < arguments.length; _i++) {
    optionalParams[_i - 1] = arguments[_i];
  }
  if (process.env.NODE_ENV === "development") {
    console.log.apply(console, __spreadArray(["[Chatbot Agent SDK] " + message], optionalParams));
  }
}
var baseURL = "/chat/v2/";
var fetch = createRequest({
  baseURL: baseURL
});
fetch.interceptors.request.use(function (config) {
  var passGateway = getPassGateWay(config.baseURL) || getHost.getChatbotHost();
  var suffix = getCSChatUUID();
  var region = getCSChatRegion();
  config.headers.common["shopee-region"] = getHost.COUNTRY;
  config.headers.common["user-region"] = region || getHost.COUNTRY;
  if (suffix) {
    config.headers.common["token-suffix"] = suffix;
  }
  // @ts-ignore
  config.requestStartTime = Date.now();
  return exports.__assign(exports.__assign({}, config), {
    baseURL: passGateway ? "https://" + passGateway + config.baseURL : config.baseURL
  });
});
fetch.interceptors.response.use(handleSuccess, handleError);
function grayReleaseConfig(params) {
  return fetch.get("/inhosue_gray_release_config", {
    params: exports.__assign({
      // 对于 chatbot 和 seller 写死 other 即可
      entry_point: "other"
    }, params)
  });
}
function enquiryTypesList(params) {
  return fetch.get("/enquiry_types_list", {
    params: params
  });
}
function uploadChatbotMessage(params) {
  return fetch.post("/upload_chatbot_message", params);
}
function unreadMessage(params) {
  return fetch.get("/unread_message", {
    params: params
  });
}
var HEADER_SESSION_KEY_NAME = "Session-Key";
// session
var initSession = function initSession(params) {
  return __awaiter(void 0, void 0, void 0, function () {
    return __generator(this, function (_a) {
      switch (_a.label) {
        case 0:
          return [4 /*yield*/, fetch.get("/init_session", {
            params: params,
            baseURL: "/chat/v1"
          })];
        case 1:
          return [2 /*return*/, _a.sent()];
      }
    });
  });
};
var initChat = function initChat(sessionKey, params) {
  return __awaiter(void 0, void 0, void 0, function () {
    var _a;
    return __generator(this, function (_b) {
      switch (_b.label) {
        case 0:
          return [4 /*yield*/, fetch.post("/init_chat", params, {
            baseURL: "/chat/v1",
            headers: (_a = {}, _a[HEADER_SESSION_KEY_NAME] = sessionKey, _a)
          })];
        case 1:
          return [2 /*return*/, _b.sent()];
      }
    });
  });
};
var initChasitor = function initChasitor(sessionKey, params) {
  return __awaiter(void 0, void 0, void 0, function () {
    var _a;
    return __generator(this, function (_b) {
      switch (_b.label) {
        case 0:
          return [4 /*yield*/, fetch.post("/init_chasitor", params, {
            baseURL: "/chat/v1",
            headers: (_a = {}, _a[HEADER_SESSION_KEY_NAME] = sessionKey, _a)
          })];
        case 1:
          return [2 /*return*/, _b.sent()];
      }
    });
  });
};
// img
var postImg = function postImg(formData) {
  return __awaiter(void 0, void 0, void 0, function () {
    return __generator(this, function (_a) {
      switch (_a.label) {
        case 0:
          return [4 /*yield*/, fetch.post("/image/upload", formData, {
            baseURL: "/chat/v1",
            headers: {
              "Content-Type": "multipart/form-data"
            }
          })];
        case 1:
          return [2 /*return*/, _a.sent()];
      }
    });
  });
};
// chat
var getMessage = function getMessage(sessionKey, message_id, options) {
  return __awaiter(void 0, void 0, void 0, function () {
    var params;
    var _a;
    return __generator(this, function (_b) {
      switch (_b.label) {
        case 0:
          params = {
            message_id: message_id,
            from: "h5"
          };
          return [4 /*yield*/, fetch.get("/chat_message", exports.__assign({
            params: params,
            baseURL: "/chat/v1",
            headers: (_a = {}, _a[HEADER_SESSION_KEY_NAME] = sessionKey, _a)
          }, options))];
        case 1:
          return [2 /*return*/, _b.sent()];
      }
    });
  });
};
var postMessage = function postMessage(sessionKey, params) {
  return __awaiter(void 0, void 0, void 0, function () {
    var _a;
    return __generator(this, function (_b) {
      switch (_b.label) {
        case 0:
          return [4 /*yield*/, fetch.post("/chat_message", params, {
            baseURL: "/chat/v1",
            headers: (_a = {}, _a[HEADER_SESSION_KEY_NAME] = sessionKey, _a)
          })];
        case 1:
          return [2 /*return*/, _b.sent()];
      }
    });
  });
};
var chatEnd = function chatEnd(sessionKey, params) {
  if (params === void 0) {
    params = {};
  }
  return __awaiter(void 0, void 0, void 0, function () {
    var _a;
    return __generator(this, function (_b) {
      switch (_b.label) {
        case 0:
          return [4 /*yield*/, fetch.post("/chat_end", exports.__assign({
            reason: "client"
          }, params), {
            baseURL: "/chat/v1",
            headers: (_a = {}, _a[HEADER_SESSION_KEY_NAME] = sessionKey, _a)
          })];
        case 1:
          return [2 /*return*/, _b.sent()];
      }
    });
  });
};
var getChatHistory = function getChatHistory(sessionKey, params) {
  return __awaiter(void 0, void 0, void 0, function () {
    var _a;
    return __generator(this, function (_b) {
      switch (_b.label) {
        case 0:
          return [4 /*yield*/, fetch.get("/chat_history", {
            params: params,
            baseURL: "/chat/v1",
            headers: (_a = {}, _a[HEADER_SESSION_KEY_NAME] = sessionKey, _a)
          })];
        case 1:
          return [2 /*return*/, _b.sent()];
      }
    });
  });
};
var chatNotTyping = function chatNotTyping(sessionKey) {
  return __awaiter(void 0, void 0, void 0, function () {
    var _a;
    return __generator(this, function (_b) {
      switch (_b.label) {
        case 0:
          return [4 /*yield*/, fetch.post("/chasitor_not_typing", null, {
            baseURL: "/chat/v1",
            headers: (_a = {}, _a[HEADER_SESSION_KEY_NAME] = sessionKey, _a)
          })];
        case 1:
          return [2 /*return*/, _b.sent()];
      }
    });
  });
};
var chatTyping = function chatTyping(sessionKey) {
  return __awaiter(void 0, void 0, void 0, function () {
    var _a;
    return __generator(this, function (_b) {
      switch (_b.label) {
        case 0:
          return [4 /*yield*/, fetch.post("/chasitor_typing", null, {
            baseURL: "/chat/v1",
            headers: (_a = {}, _a[HEADER_SESSION_KEY_NAME] = sessionKey, _a)
          })];
        case 1:
          return [2 /*return*/, _b.sent()];
      }
    });
  });
};
var postChatHeartbeat = function postChatHeartbeat(userId) {
  return __awaiter(void 0, void 0, void 0, function () {
    return __generator(this, function (_a) {
      switch (_a.label) {
        case 0:
          return [4 /*yield*/, fetch.post("/heartbeat", {
            id: String(userId)
          }, {
            baseURL: "/chat/v1"
          })];
        case 1:
          return [2 /*return*/, _a.sent()];
      }
    });
  });
};
var getQueueList = function getQueueList(params) {
  return __awaiter(void 0, void 0, void 0, function () {
    return __generator(this, function (_a) {
      switch (_a.label) {
        case 0:
          return [4 /*yield*/, fetch.get("/queue_conf", {
            baseURL: "/chat/v1",
            params: params
          })];
        case 1:
          return [2 /*return*/, _a.sent()];
      }
    });
  });
};
exports.CastType = void 0;
(function (CastType) {
  CastType[CastType["Positive"] = 0] = "Positive";
  CastType[CastType["Neutral"] = 1] = "Neutral";
  CastType[CastType["Unlike"] = 2] = "Unlike";
})(exports.CastType || (exports.CastType = {}));
var sendRating = function sendRating(data) {
  return __awaiter(void 0, void 0, void 0, function () {
    return __generator(this, function (_a) {
      switch (_a.label) {
        case 0:
          return [4 /*yield*/, fetch.post("/send_rating", {
            csat_object: JSON.stringify({
              Shopee_ID_Community_Language__c: "EN_US",
              Shopee_ID_Chat_Id__c: data.sessionId,
              Shopee_Chat_Key__c: data.sessionId,
              Shopee_ID_Source_Type__c: "Mobile",
              Shopee_ID_Positive_CSAT__c: data.cast === exports.CastType.Positive,
              Shopee_ID_Neutral_CSAT__c: data.cast === exports.CastType.Neutral,
              Shopee_ID_Unliked_CSAT__c: data.cast === exports.CastType.Unlike,
              Shopee_ID_Chat_Feedbacks__c: data.feedback
            })
          }, {
            baseURL: "/chat/v1"
          })];
        case 1:
          return [2 /*return*/, _a.sent()];
      }
    });
  });
};
var uploadFile = function uploadFile(file, config) {
  return __awaiter(void 0, void 0, void 0, function () {
    var formData;
    return __generator(this, function (_a) {
      switch (_a.label) {
        case 0:
          formData = new FormData();
          formData.append("file", file);
          return [4 /*yield*/, fetch.post("/upload_file", formData, exports.__assign({
            baseURL: "/chat/v1",
            headers: {
              "Content-Type": "multipart/form-data"
            }
          }, config)).then(function (res) {
            if (res.code !== 0) {
              var error = new Error(res.msg || "Request failed with data code " + (res.code || "UNKNOWN"));
              return error;
            }
            return res;
          }).catch(function (err) {
            return err;
          })];
        case 1:
          return [2 /*return*/, _a.sent()];
      }
    });
  });
};
var createMultipartUpload = function createMultipartUpload(file_name, file_size) {
  return __awaiter(void 0, void 0, void 0, function () {
    return __generator(this, function (_a) {
      switch (_a.label) {
        case 0:
          return [4 /*yield*/, fetch.post("/create_multipart_upload", {
            file_name: file_name,
            file_size: file_size
          }, {
            baseURL: "/chat/v1"
          }).then(function (res) {
            if (res.code !== 0) {
              var error = new Error(res.msg || "Request failed with data code " + (res.code || "UNKNOWN"));
              return error;
            }
            return res;
          }).catch(function (err) {
            return err;
          })];
        case 1:
          return [2 /*return*/, _a.sent()];
      }
    });
  });
};
var uploadPart = function uploadPart(upload_id, file_key, part_num, blob, config) {
  return __awaiter(void 0, void 0, void 0, function () {
    var search;
    return __generator(this, function (_a) {
      switch (_a.label) {
        case 0:
          search = new URLSearchParams({
            upload_id: upload_id,
            file_key: file_key,
            part_num: part_num.toString()
          });
          return [4 /*yield*/, fetch.post("/upload_part?" + search.toString(), blob, exports.__assign({
            baseURL: "/chat/v1"
          }, config)).then(function (res) {
            if (res.code !== 0) {
              var error = new Error(res.msg || "Request failed with data code " + (res.code || "UNKNOWN"));
              return error;
            }
            return res;
          }).catch(function (err) {
            return err;
          })];
        case 1:
          return [2 /*return*/, _a.sent()];
      }
    });
  });
};
var completeMultipartUpload = function completeMultipartUpload(upload_id, file_key, completed_parts) {
  return __awaiter(void 0, void 0, void 0, function () {
    return __generator(this, function (_a) {
      switch (_a.label) {
        case 0:
          return [4 /*yield*/, fetch.post("/complete_multipart_upload", {
            upload_id: upload_id,
            file_key: file_key,
            completed_parts: completed_parts
          }, {
            baseURL: "/chat/v1"
          }).then(function (res) {
            if (res.code !== 0) {
              var error = new Error(res.msg || "Request failed with data code " + (res.code || "UNKNOWN"));
              return error;
            }
            return res;
          }).catch(function (err) {
            return err;
          })];
        case 1:
          return [2 /*return*/, _a.sent()];
      }
    });
  });
};
var abortMultipartUpload = function abortMultipartUpload(upload_id, file_key) {
  return __awaiter(void 0, void 0, void 0, function () {
    return __generator(this, function (_a) {
      switch (_a.label) {
        case 0:
          return [4 /*yield*/, fetch.post("/abort_multipart_upload", {
            upload_id: upload_id,
            file_key: file_key
          }, {
            baseURL: "/chat/v1"
          }).then(function (res) {
            if (res.code !== 0) {
              var error = new Error(res.msg || "Request failed with data code " + (res.code || "UNKNOWN"));
              return error;
            }
            return res;
          }).catch(function (err) {
            return err;
          })];
        case 1:
          return [2 /*return*/, _a.sent()];
      }
    });
  });
};
var validateDownload = function validateDownload(file_key) {
  return __awaiter(void 0, void 0, void 0, function () {
    return __generator(this, function (_a) {
      switch (_a.label) {
        case 0:
          return [4 /*yield*/, fetch.get("/validate_download", {
            params: {
              file_key: file_key
            }
          }).then(function (res) {
            if (res.code !== 0) {
              var error = new Error(res.msg || "Request failed with data code " + (res.code || "UNKNOWN"));
              return error;
            }
            return res;
          }).catch(function (err) {
            return err;
          })];
        case 1:
          return [2 /*return*/, _a.sent()];
      }
    });
  });
};
var getDownloadUrl = function getDownloadUrl(file_key) {
  return __awaiter(void 0, void 0, void 0, function () {
    return __generator(this, function (_a) {
      switch (_a.label) {
        case 0:
          return [4 /*yield*/, fetch.get("/download", {
            params: {
              file_key: file_key
            }
          })];
        case 1:
          return [2 /*return*/, _a.sent()];
      }
    });
  });
};
function downloadWithUrl(url) {
  if (!url) {
    return;
  }
  var ele = document.createElement("a");
  ele.download = "";
  ele.href = url;
  document.body.append(ele);
  ele.click();
}
var getUserSession$1 = function getUserSession$1(params) {
  return __awaiter(void 0, void 0, void 0, function () {
    return __generator(this, function (_a) {
      switch (_a.label) {
        case 0:
          return [4 /*yield*/, fetch.get("/user_session", {
            params: params,
            baseURL: "/chat/v1"
          })];
        case 1:
          return [2 /*return*/, _a.sent()];
      }
    });
  });
};
var getChatInfo = function getChatInfo(params) {
  return __awaiter(void 0, void 0, void 0, function () {
    return __generator(this, function (_a) {
      switch (_a.label) {
        case 0:
          return [4 /*yield*/, fetch.get("/get_chat_config", {
            params: params,
            baseURL: "/chat/v1"
          })];
        case 1:
          return [2 /*return*/, _a.sent()];
      }
    });
  });
};
/**
 * 获取live chat配置
 *
 * @export
 * @param {LiveChatConfigReqType} [params]
 * @returns {(Promise<LiveChatConfigResType | Error>)}
 */
function getLiveChatConfig(params) {
  return fetch.get("/get_general_switch_config", {
    params: params,
    baseURL: '/chat/v1'
  });
}
/**
 * 发送消息
 *
 * @export
 * @param {MsgHttp} [params]
 * @param {{ timeout: number }} [opt]
 * @returns {(Promise<BaseRes<SendMessageAckBizContentType> | Error>)}
 */
function sendMsg(params, opt) {
  var timeout = (opt || {}).timeout;
  return fetch.post("/msgs/send_msg", params, {
    baseURL: "/chat/v2",
    timeout: timeout
  });
}
/**
 * 上传EnquiryInfo
 *
 * @export
 * @param {UploadEnquiryInfoBizContentType} [params]
 * @returns {(Promise<UploadEnquiryInfoAckBizContentType | Error>)}
 */
function uploadEnquiryInfo(params) {
  return fetch.post("/session/upload_enquiry_info", params, {
    baseURL: "/chat/v2"
  });
}
/**
 * 开启session
 *
 * @export
 * @param {StartSessionBizContentType} params
 * @returns {(Promise<StartSessionAckBizContentType | Error>)}
 */
function sendStartSession(params) {
  return fetch.post("/session/start_session", params, {
    baseURL: "/chat/v2"
  });
}
/**
 * 用户主动关闭session
 *
 * @export
 * @param {CloseSessionBizContentType} params
 * @returns {(Promise<CloseSessionAckBizContentType | Error>)}
 */
function sendUserCloseSession(params) {
  return fetch.post("/session/user_close_session", params, {
    baseURL: "/chat/v2"
  });
}
/**
 * 拉取消息
 *
 * @export
 * @returns {(Promise<LiveChatConfigResType | Error>)}
 */
function pollingMessage(params) {
  return fetch.get("/msgs/poll_message", {
    params: params,
    baseURL: "/chat/v2"
  });
}
/**
 * 拉取消息 v2
 *
 * @export
 * @returns {(Promise<LiveChatConfigResType | Error>)}
 */
function pollingMessageV2(params) {
  return fetch.get("/msgs/poll_message_v2", {
    params: params,
    baseURL: "/chat/v2"
  });
}
/**
 * 获取session信息
 *
 * @export
 * @param {StartSessionBizContentType} params
 * @returns {(Promise<BaseRes<StartSessionAckBizContentType> | Error>)}
 */
function getSessionInfo$1(params) {
  return fetch.get("/session/info", {
    params: params,
    baseURL: "/chat/v2"
  });
}
/**
 * 发送ack消息
 *
 * @export
 * @param {SendAckReqType} [params]
 * @returns {(Promise<BaseRes<SendAckResType> | Error>)}
 */
function sendAck(params) {
  return fetch.post("/msgs/ack_msg", params, {
    baseURL: "/chat/v2"
  });
}
/**
 * 新的合并接口
 *
 * @export
 * @param {UploadEnquiryInfoBizContentType} params
 * @returns {(Promise<UploadChatbotMessageResType | Error>)}
 */
function createNewSession(params) {
  return fetch.post("/session/init_session", params);
}
exports.TraceLogger = TraceLogger;
exports.__awaiter = __awaiter;
exports.__extends = __extends;
exports.__generator = __generator;
exports.__rest = __rest;
exports.__spreadArray = __spreadArray;
exports.abortMultipartUpload = abortMultipartUpload;
exports.addMessageListener = addMessageListener;
exports.agentChatScheduler = agentChatScheduler;
exports.baseURL = baseURL;
exports.batchReportGrafana = batchReportGrafana;
exports.batchReportGrafanaTime = batchReportGrafanaTime;
exports.canEmit = canEmit;
exports.chatBeforeInitMessageKey = chatBeforeInitMessageKey;
exports.chatCloseKey = chatCloseKey;
exports.chatConfigChangeKey = chatConfigChangeKey;
exports.chatEnd = chatEnd;
exports.chatErrorKey = chatErrorKey;
exports.chatInitMessageKey = chatInitMessageKey;
exports.chatNotTyping = chatNotTyping;
exports.chatReceiveMessageKey = chatReceiveMessageKey;
exports.chatRestoreKey = chatRestoreKey;
exports.chatSendMessageCompleteKey = chatSendMessageCompleteKey;
exports.chatSendMessageKey = chatSendMessageKey;
exports.chatStopKey = chatStopKey;
exports.chatTyping = chatTyping;
exports.chatUnSendMessageKey = chatUnSendMessageKey;
exports.checkMasterIsExist = checkMasterIsExist;
exports.completeMultipartUpload = completeMultipartUpload;
exports.configPassGateWay = configPassGateWay;
exports.connectionInfoKey = connectionInfoKey;
exports.createMultipartUpload = createMultipartUpload;
exports.createNewSession = createNewSession;
exports.createRequest = createRequest;
exports.currentIdKey = currentIdKey;
exports.devLog = devLog;
exports.downloadWithUrl = downloadWithUrl;
exports.enquiryTypesList = enquiryTypesList;
exports.fetch = fetch;
exports.getCSChatRegion = getCSChatRegion;
exports.getChatHistory = getChatHistory;
exports.getChatInfo = getChatInfo;
exports.getDownloadUrl = getDownloadUrl;
exports.getLiveChatConfig = getLiveChatConfig;
exports.getMessage = getMessage;
exports.getPassWSGateWay = getPassWSGateWay;
exports.getQueueList = getQueueList;
exports.getRandomNumberWithTimeStamp = getRandomNumberWithTimeStamp;
exports.getRandomNumbers = getRandomNumbers;
exports.getSessionInfo = getSessionInfo$1;
exports.getSessionInfo$1 = getSessionInfo;
exports.getSessionStorage = getSessionStorage;
exports.getStorage = getStorage;
exports.getUserSession = getUserSession$1;
exports.grayReleaseConfig = grayReleaseConfig;
exports.handleError = handleError;
exports.handleSuccess = handleSuccess;
exports.heartbeatInterval = heartbeatInterval;
exports.initChasitor = initChasitor;
exports.initChat = initChat;
exports.initConnectionInfoKey = initConnectionInfoKey;
exports.initSession = initSession;
exports.masterHeartbeatKey = masterHeartbeatKey;
exports.masterIdKey = masterIdKey;
exports.masterTimerKey = masterTimerKey;
exports.pollingMessage = pollingMessage;
exports.pollingMessageV2 = pollingMessageV2;
exports.postChatHeartbeat = postChatHeartbeat;
exports.postImg = postImg;
exports.postMessage = postMessage;
exports.ratingChatKey = ratingChatKey;
exports.readedMessageCountKey = readedMessageCountKey;
exports.reportDebugLog = reportDebugLog;
exports.reportErrorLog = reportErrorLog;
exports.sendAck = sendAck;
exports.sendMsg = sendMsg;
exports.sendRating = sendRating;
exports.sendStartSession = sendStartSession;
exports.sendUserCloseSession = sendUserCloseSession;
exports.setSessionStorage = setSessionStorage;
exports.setStorage = setStorage;
exports.unreadMessage = unreadMessage;
exports.uploadChatbotMessage = uploadChatbotMessage;
exports.uploadEnquiryInfo = uploadEnquiryInfo;
exports.uploadFile = uploadFile;
exports.uploadPart = uploadPart;
exports.validateDownload = validateDownload;